module.exports = __webpack_public_path__ + "portal-static/img/queuing.dbf860e3.gif";